import cn from 'classnames';
import { TextareaAutosize, TextareaAutosizeProps } from '@mui/material';

import styles from './oTextarea.module.scss';

interface IProps extends TextareaAutosizeProps {
  label?: string;
  classes?: {
    input?: string;
  };
  textAreaHeight?: 'small' | 'medium' | 'large';
}

const OTextArea: React.FC<IProps> = ({
  label,
  value,
  classes,
  placeholder,
  maxLength,
  textAreaHeight = 'small',
  onChange,
  ...rest
}) => {
  return (
    <div className={cn(styles.oTextareaContainer)}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.inputContainer}>
        <TextareaAutosize
          className={cn(styles.textareaInput, styles[textAreaHeight], classes?.input)}
          placeholder={placeholder}
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          name="textarea"
          {...rest}
        />
        {!!(maxLength && maxLength > 0) && (
          <div className={styles.textareaFooterContainer}>
            <div className={styles.charactersLimit}>{`${String(value).trim().length} / ${maxLength}`}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OTextArea;
